module.exports = ReactRouter;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 35
// module chunks = 1